/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-20-05 06:08:32
 *
 *******************************************************/
// @flow

import type { Action } from './store.type';

export const GET_SWATCH_SETTINGS_REQUEST = 'GET_SWATCH_SETTINGS_REQUEST';
type GET_SWATCH_SETTINGS_REQUEST_TYPE = 'GET_SWATCH_SETTINGS_REQUEST';

export const GET_SWATCH_SETTINGS_SUCCESS = 'GET_SWATCH_SETTINGS_SUCCESS';
type GET_SWATCH_SETTINGS_SUCCESS_TYPE = 'GET_SWATCH_SETTINGS_SUCCESS';

export const GET_SWATCH_SETTINGS_FAILURE = 'GET_SWATCH_SETTINGS_FAILURE';
type GET_SWATCH_SETTINGS_FAILURE_TYPE = 'GET_SWATCH_SETTINGS_FAILURE';

export const UPDATE_SWATCH_SETTINGS_REQUEST = 'UPDATE_SWATCH_SETTINGS_REQUEST';
type UPDATE_SWATCH_SETTINGS_REQUEST_TYPE = 'UPDATE_SWATCH_SETTINGS_REQUEST';

export const UPDATE_SWATCH_SETTINGS_SUCCESS = 'UPDATE_SWATCH_SETTINGS_SUCCESS';
type UPDATE_SWATCH_SETTINGS_SUCCESS_TYPE = 'UPDATE_SWATCH_SETTINGS_SUCCESS';

export const UPDATE_SWATCH_SETTINGS_FAILURE = 'UPDATE_SWATCH_SETTINGS_FAILURE';
type UPDATE_SWATCH_SETTINGS_FAILURE_TYPE = 'UPDATE_SWATCH_SETTINGS_FAILURE';

type SwatchSettingsSuccess = {
  data: Object
};

type SwatchSettingsFailure = {
  error: any
};
type GetSwatchSettingsRequestAction = Action<GET_SWATCH_SETTINGS_REQUEST_TYPE, null>;

type GetSwatchSettingsSuccessAction = Action<
  GET_SWATCH_SETTINGS_SUCCESS_TYPE,
  SwatchSettingsSuccess
>;

type GetSwatchSettingsFailureAction = Action<
  GET_SWATCH_SETTINGS_FAILURE_TYPE,
  SwatchSettingsFailure
>;

type UpdateSwatchSettingsRequestAction = Action<UPDATE_SWATCH_SETTINGS_REQUEST_TYPE, null>;

type UpdateSwatchSettingsSuccessAction = Action<
  UPDATE_SWATCH_SETTINGS_SUCCESS_TYPE,
  SwatchSettingsSuccess
>;

type UpdateSwatchSettingsFailureAction = Action<
  UPDATE_SWATCH_SETTINGS_FAILURE_TYPE,
  SwatchSettingsFailure
>;

export type SwatchSettingsAction =
  | GetSwatchSettingsRequestAction
  | GetSwatchSettingsSuccessAction
  | GetSwatchSettingsFailureAction
  | UpdateSwatchSettingsRequestAction
  | UpdateSwatchSettingsSuccessAction
  | UpdateSwatchSettingsFailureAction;

export type SwatchSettingsState = {
  getLoading: boolean,
  updateLoading: boolean,
  success: boolean,
  error: any,
  swatchSettings: {}
};
